import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import { LEGAL_DOCS, COMPANY } from '../legal/legalContent.js';

// Renders a single legal document from the shared content registry.
// `slug` selects which document (privacy | terms | business-terms).
function LegalDocPage({ slug }) {
  const doc = LEGAL_DOCS[slug];

  if (!doc) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#f7fafc' }}>
        <Navbar />
        <Box sx={{ flex: 1, maxWidth: 800, mx: 'auto', px: 3, py: 8 }}>
          <Typography variant="h5">Document not found.</Typography>
        </Box>
        <Footer />
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#f7fafc' }}>
      <Navbar />

      <Box
        component="main"
        sx={{
          flex: 1,
          width: '100%',
          maxWidth: 820,
          mx: 'auto',
          px: { xs: 2.5, sm: 4 },
          py: { xs: 4, sm: 6 },
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: 800, color: '#1e3a4f', lineHeight: 1.2 }}
        >
          {doc.title}
        </Typography>

        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          Effective date: {COMPANY.effectiveDate}
        </Typography>

        {doc.subtitle && (
          <Typography variant="body1" sx={{ mt: 2, color: '#42606f', lineHeight: 1.7 }}>
            {doc.subtitle}
          </Typography>
        )}

        <Divider sx={{ my: 3 }} />

        {doc.sections.map((section) => (
          <Box key={section.heading} component="section" sx={{ mb: 3.5 }}>
            <Typography
              variant="h6"
              component="h2"
              sx={{ fontWeight: 700, color: '#23495f', mb: 1.25 }}
            >
              {section.heading}
            </Typography>

            {section.content.map((block, i) => {
              if (block.type === 'ul') {
                return (
                  <Box
                    key={i}
                    component="ul"
                    sx={{ pl: 3, my: 1, color: '#3f5b69', '& li': { mb: 0.75, lineHeight: 1.7 } }}
                  >
                    {block.items.map((item, j) => (
                      <li key={j}>{item}</li>
                    ))}
                  </Box>
                );
              }
              return (
                <Typography
                  key={i}
                  variant="body1"
                  sx={{ color: '#3f5b69', lineHeight: 1.8, mb: 1.5 }}
                >
                  {block.text}
                </Typography>
              );
            })}
          </Box>
        ))}
      </Box>

      <Footer />
    </Box>
  );
}

export default LegalDocPage;
